import React, { createContext, useContext, useEffect } from 'react';

const FlexCaseBackEndConnectionSocketContext = createContext();

export function FlexCaseBackEndConnectionSocketProvider({
  children,
  socketFlexCaseBackEnd
}) {
  useEffect(() => {
    return () => {
      socketFlexCaseBackEnd.disconnect();
    };
  }, [socketFlexCaseBackEnd]);

  return (
    <>
      <FlexCaseBackEndConnectionSocketContext.Provider
        value={{
          socketFlexCaseBackEnd
        }}
      >
        {children}
      </FlexCaseBackEndConnectionSocketContext.Provider>
    </>
  );
}

export function useFlexCaseBackEndConnectionSocket() {
  const context = useContext(FlexCaseBackEndConnectionSocketContext);
  return context;
}
